import React from 'react';
import {
    MobileDateTimePicker,
    DesktopDateTimePicker,
    PickerChangeHandlerContext,
    DateTimeValidationError,
} from '@mui/x-date-pickers';
import { InputLabel } from '@mui/material';
import { Moment } from 'moment';

interface Props {
    readonly label?: string;
    readonly value: Moment;
    readonly onChange: (from: Moment | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => void;
    readonly disablePast?: boolean;
}

export class DateTimePicker extends React.Component<Props> {
    render() {
        const { label, value, onChange, disablePast } = this.props;
        return (
            <>
                {label && label !== '' && (
                    <InputLabel>{label}</InputLabel>
                )}
                <MobileDateTimePicker
                    sx={{
                        display: {
                            xs: 'block',
                            sm: 'none'
                        },
                        '& .MuiOutlinedInput-root': {
                            width: '100%',
                        },
                    }}
                    value={value}
                    onChange={onChange}
                    disablePast={disablePast}
                />
                <DesktopDateTimePicker
                    sx={{
                        display: {
                            xs: 'none',
                            sm: 'block'
                        },
                        '& .MuiOutlinedInput-root': {
                            width: '100%',
                        },
                    }}
                    value={value}
                    onChange={onChange}
                    disablePast={disablePast}
                />
            </>
        );
    }
}